import { useLocation } from 'react-router-dom'
import useRedirect from './useRedirect'

// An event opened by its number (/Town/events/220219) switches to its slug address in the same
// place (town or feed). A slug made only of digits matches first, so it stays put.
const useEventSlugAddress = (param: string | undefined, event: { slug?: string } | null): void => {
  const { pathname, search, hash } = useLocation()
  const opensByNumber = !!param && /^\d+$/.test(param) && !!event?.slug && event.slug.toLowerCase() !== param.toLowerCase()

  useRedirect(opensByNumber && `${pathname.replace(new RegExp(`/${param}/?$`), `/${event?.slug}`)}${search}${hash}`)
}

export default useEventSlugAddress
